import { styled } from "@mui/material/styles";

/**
 * There is a multitude of import options for the `styled` function.
 *
 * We should use `import { styled } from "@mui/material/styles";`
 *
 * However, since the automatic import of your IDE may fail to import
 * from the right package, we provide this little alias `lxStyled`
 * which uses the right package.
 *
 * @package Theme
 * @example
 * import { lxStyled } from "@lxo-blocks/react"
 *
 * const MyStyledComponent = lxStyled( ({theme}) => ({
 *    margin: theme.spacing(2)
 * })
 */
export const lxStyled = styled;
